import {useEffect, useState} from "react"; // make sure this points to your Supabase client
import {format} from "date-fns";
import {supabase} from "../../services/supabase";
import PublishBlog from "./BlogPublish";
import EditBlog from "./BlogEdit";

export default function BlogList() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState(null);


    const fetchBlogs = async () => {

        setLoading(true);
        const { data, error } = await supabase
            .from("blogs")
            .select("*")
            .order("created_at", { ascending: false });

        if (error) console.error("Fetch error:", error);
        else {setBlogs(data)
        }

        setLoading(false);
    };

    const handleDelete = async (id) => {
        const { error } = await supabase.from("blogs").delete().eq("id", id);
        if (!error) await fetchBlogs();
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    return (
        <div className="container mx-auto px-4 py-8">
            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
                <h2 className="text-4xl font-bold text-gray-900">Blog Posts</h2>
                <button
                    onClick={() => setShowModal(true)}
                    className="inline-flex items-center px-4 py-2 text-white bg-orange-600 hover:bg-orange-700 rounded-lg shadow transition duration-200"
                >
                    + Publish New Post
                </button>
            </div>
            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
                    <div className="bg-white w-full max-w-4xl max-h-[90vh] rounded-lg shadow-lg flex flex-col overflow-hidden">

                        {/* Header */}
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                            <h3 className="text-xl font-semibold text-gray-900">Publish New Blog Post</h3>
                            <button
                                onClick={() => setShowModal(false)}
                                className="text-gray-500 hover:text-red-500"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>

                        {/* Scrollable Body */}
                        <div className="overflow-y-auto px-6 py-4 flex-1">
                            <PublishBlog />
                        </div>
                    </div>
                </div>
            )}
            {showEditModal && selectedBlog && (
                <EditBlog
                    blog={selectedBlog}
                    onClose={() => {
                        setShowEditModal(false);
                        setSelectedBlog(null);
                    }}
                    onUpdate={fetchBlogs}
                />
            )}

            {/* Blog List */}
            {loading ? (
                <p className="text-gray-500">Loading...</p>
            ) : blogs.length === 0 ? (
                <p className="text-gray-500">No blog posts available.</p>
            ) : (
                <ul className="divide-y divide-gray-200">
                    {blogs.map((blog) => (
                        <li key={blog.id} className="py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <div className="flex-1">
                                <h3 className="text-2xl font-semibold text-gray-900">{blog.title}</h3>
                                <p className="text-sm text-gray-500">
                                    Published on {format(new Date(blog.created_at), "MMMM d, yyyy")}
                                </p>
                                {(() => {
                                    let plainText ;

                                    try {
                                        const parsedContent = JSON.parse(blog.content || "[]");

                                        // Extract all paragraph text safely
                                        plainText = parsedContent
                                            .flatMap(block =>
                                                block.children?.map(child => child.text) ?? []
                                            )
                                            .join(" ");
                                    } catch (err) {
                                        // Fallback to raw string if content isn't valid JSON
                                        plainText = blog.content || "";
                                    }

                                    return (
                                        <p className="mt-2 text-gray-700 line-clamp-2">
                                            {plainText}
                                        </p>
                                    );
                                })()}</div>
                            <div className="flex gap-2">
                                <button
                                    className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-md text-sm font-semibold"
                                    onClick={() => {setSelectedBlog(blog);
                                    setShowEditModal(true)}}

                                >
                                    Edit
                                </button>
                                <button
                                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-semibold"
                                    onClick={() => handleDelete(blog.id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
